// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"d4304297","669":"73c516f2","677":"4ed3051a"}[chunkId] + ".chunk.js";
};